<template>
  <div :class="$style.header">
    <div :class="$style.left">
      <ButtonBack :class="$style.back" />
      <span :class="$style.dot" />
      <div :class="$style.breadcrumbs">
        <NuxtLink to="/" :class="$style.link">Главная</NuxtLink>
        <span> / </span>
        <NuxtLink to="/events" :class="$style.link">мероприятия</NuxtLink>
        <span> / </span>
        <span>СПИКЕРЫ</span>
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.header {
  display: flex;
  align-items: center;
  padding: var(--space-2x) 110px;
  background-color: var(--color-gray-bg);
}

.left {
  display: flex;
  align-items: center;
  gap: var(--space-1x);
}

.dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: var(--color-gray-text);
  flex-shrink: 0;
}

.breadcrumbs {
  @include text_caption1_caps;
  color: var(--color-gray-text);
}

.link {
  color: var(--color-gray-text);
  text-decoration: none;

  &:hover {
    color: var(--color-red-1);
  }
}

@media (max-width: 1379px) {
  .header {
    padding: var(--space-2x) var(--space-2-5x);
  }
}

@media (max-width: 479px) {
  .header {
    padding: 10px var(--space-2-5x);
  }

  .back,
  .breadcrumbs {
    font-size: 8px;
    letter-spacing: 0.8px;
  }
}
</style>
